import { CircularProgress, Paper, Typography } from "@mui/material";
import axios from "axios";
import * as React from "react";
import { Chart } from "react-google-charts";
import { Config } from "../../../../config/config";
import { Helpers } from "../../../../utils/helpers";
import { DailyDeliveryAnalyticsProps, DailyDeliveryAnalyticsState } from "./types/dailyDelivery.types";

export class DailyDeliveryAnalytics extends React.Component<DailyDeliveryAnalyticsProps, DailyDeliveryAnalyticsState> {

    constructor(props) {
        super(props);

        this.state = {
            loaded: false,
            haveError: false,
            data: [],
            // Cache date range for latest request to not call multiple request with same date
            startDate: new Date(),
            endDate: new Date(),
        };
    }

    componentDidMount() {
        this.fetchData(this.props.dateRange.startDate, this.props.dateRange.endDate);
    }

    componentWillReceiveProps(props) {
        if (
            this.state.startDate.getTime() !== props.dateRange.startDate.getTime() ||
            this.state.endDate.getTime() !== props.dateRange.endDate.getTime()
        ) {
            // Fetch new data only when receiving new date range
            this.fetchData(props.dateRange.startDate, props.dateRange.endDate);
        }
    }

    fetchData = async (startDate: Date | undefined, endDate: Date | undefined) => {
        try {
            this.setState({ loaded: false, haveError: false });
            const userId = this.props.playerId;
            const searchStartDate = startDate || new Date();
            const searchEndDate = endDate || new Date();

            const response = await axios.get(`${Config.getInstance.apiUrl}/api/user/${userId}/analytics/daily_delivery`, {
                headers: {
                    Authorization: Helpers.getSessionId(),
                    env: this.props.activeEnv,
                    startDate: searchStartDate.getTime(),
                    endDate: searchEndDate.getTime(),
                },
            });

            this.setState({
                loaded: true,
                haveError: false,
                data: response.data.data,
                startDate: searchStartDate,
                endDate: searchEndDate,
            });
        } catch (error) {
            this.setState({ haveError: true, loaded: true });
        }
    }

    render() {
        return (
            <React.Fragment>
                <div style={{ float: "left", width: "50%", paddingRight: 10, paddingBottom: 20 }}>
                    <Paper style={{ height: "300px" }} className="center--content" elevation={0}>
                        {!this.state.loaded && <CircularProgress/>}
                        {this.state.loaded && this.state.haveError && <Typography variant="h3" gutterBottom>
                            Error
                        </Typography>}

                        {this.state.loaded && !this.state.haveError &&
                            <Chart
                                loader={<div>Loading Chart</div>}
                                width={"100%"}
                                height={"300px"}
                                chartType="ComboChart"
                                columns={[
                                    {
                                        type: "string",
                                        label: "Date",
                                    },
                                    {
                                        type: "number",
                                        label: "1 Tier",
                                    },
                                    {
                                        type: "number",
                                        label: "2 Tier",
                                    },
                                    {
                                        type: "number",
                                        label: "3 Tier",
                                    },
                                    {
                                        type: "number",
                                        label: "4 Tier",
                                    },
                                    {
                                        type: "number",
                                        label: "5 Tier",
                                    },
                                    {
                                        type: "number",
                                        label: "6 Tier",
                                    },
                                    {
                                        type: "number",
                                        label: "7 Tier",
                                    },
                                    {
                                        type: "number",
                                        label: "8 Tier",
                                    },
                                    {
                                        type: "number",
                                        label: "9 Tier",
                                    },
                                    {
                                        type: "number",
                                        label: "10 Tier",
                                    },
                                    {
                                        type: "number",
                                        label: "11 Tier",
                                    },
                                    {
                                        type: "number",
                                        label: "12 Tier",
                                    },
                                    {
                                        type: "number",
                                        label: "13 Tier",
                                    },
                                ]}
                                rows={this.state.data}
                                options={{
                                    title: "Daily delivery collected",
                                    vAxis: { title: "Amount" },
                                    seriesType: "bars",
                                    legend: { position: "bottom", maxLines: 3 },
                                    isStacked: true,
                                }}
                                legendToggle
                                className="chart-root"
                            />
                        }
                    </Paper>
                </div>
            </React.Fragment>
        );
    }
}
